import * as React from "react";
import Slider from "react-slick";
import { StaticImage } from "gatsby-plugin-image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PageLayout } from "../components/page";

const IndexPage = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplaySpeed: 3000,
    autoplay: true,
  };

  const [isOpen, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [givenSupport, setSupport] = React.useState(false);
  const [checked, setChecked] = React.useState(false);

  function registerSupport() {
    setSupport(true);
  }

  function ToggleMenu() {
    setOpen(!isOpen);
  }

  const handleChange = () => {
    setChecked(!checked);
  };

  function SubmitEmail(e) {
    e.preventDefault();

    console.log("Sending email: " + email);

    setEmail(email.trim().toLowerCase());

    if (!email.includes("@")) {
      // no email
    }

    fetch("https://connect.mailerlite.com/api/subscribers", {
      method: "POST",
      body: JSON.stringify({ email }),
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${process.env.MAILERLITE_API_KEY}`,
      },
    }).then((res) => {
      alert("Check your email for confirmation!");
      setEmail("");
    });
  }

  return (
    <PageLayout>
      <h2 className="text-5xl mb-16 font-thin">Jobsworth Parish Council</h2>
      <section className="bg-yellow-300 border-2 border-yellow-900 p-4 shadow-lg mb-8">
        <p className="text-xl">
          <b>
            <i>IMPORTANT ANNOUNCEMENT!</i>
          </b>
        </p>
        <p className="text-lg">
          We need all residents to show interest in the Community Newsletter
          Software Project through the Steam platform. If you are a resident*,
          please head directly to the{" "}
          <a
            href="https://store.steampowered.com/app/2749340/Jobsworth_Weekly/"
            className="underline text-blue-700"
          >
            Jobsworth Steam page{" "}
          </a>
          and click the <b>Add to your wishlist</b> button. All residents that
          add the tool to their wishlist will get a "shout out" at the next
          parish council meeting, after the apologies for absences are read but
          before the declarations of interest.
        </p>
        {givenSupport ? (
          <p className="text-2xl font-thin">
            Thank you for supporting the Community Newsletter Project!
          </p>
        ) : (
          <div className="flex flex-col items-center">
            <div>
              <input
                type="checkbox"
                name="honesty"
                id="honesty"
                checked={checked}
                onChange={handleChange}
              />
              <label htmlFor="honesty" className="ml-4">
                I confirm I have both wishlisted the project on Steam and am a
                legal resident of Jobsworth.
              </label>
            </div>
            <button
              disabled={!checked}
              className="p-4 mt-4 w-80 disabled:cursor-not-allowed disabled:opacity-30 bg-yellow-600 text-white cursor-pointer hover:bg-yellow-800"
              onClick={registerSupport}
            >
              Request Parish Council Shoutout
            </button>
          </div>
        )}
        <p className="text-sm mt-4">
          *We really have to stress the importance that this website is{" "}
          <b>only</b> for residents of Jobsworth. If you are not a resident
          please close this tab.
        </p>
      </section>
      <StaticImage
        src="../images/jobsworthparishhall.jpg"
        alt="jobsworth parish hall"
      />
      <h3 className="bg-blue-800 p-4 mb-4 text-2xl font-semibold text-white italic text-center">
        Your Parish Council is the closest tier of local government to you
      </h3>
      <p>
        This site enables you to catch up with the latest happenings and goings
        on in the village of Jobsworth.
      </p>
      <p>
        Please subscribe to our email newsletter to receive exciting updates on
        planning applications, local upcoming events, and updates on council led
        projects such as the{" "}
        <b>Jobsworth Community Newsletter Software Project.</b>
      </p>
      <div className="flex flex-col justify-center items-center mb-4">
        <form className="flex flex-col w-96" onSubmit={SubmitEmail}>
          <input
            className="p-4 mb-2"
            type="email"
            placeholder="your@email.com"
            required
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          ></input>
          <button className="p-4 bg-yellow-600 text-white cursor-pointer hover:bg-yellow-800">
            Subscribe
          </button>
        </form>
      </div>
      <hr className="mb-8" />
      <section className="bg-yellow-300 border-2 border-yellow-900 p-4 shadow-lg mb-8">
        <p>
          All members of the public are entitled to attend the meetings and are
          cordially invited by the Council to do so. Time will be set aside
          prior to the published agenda to enable informal discussion to take
          place.
        </p>
        <h4 className="text-xl">
          Agendas will be posted to notice boards and this website
        </h4>
      </section>
      <hr className="mb-4" />
      <Slider {...settings}>
        <div>
          <StaticImage src="../images/IMG_0061.jpeg" alt="slide1" />
        </div>
        <div>
          <StaticImage src="../images/IMG_0266.jpeg" alt="slide2" />
        </div>
        <div>
          <StaticImage src="../images/IMG_0583.jpeg" alt="slide3" />
        </div>
        <div>
          <StaticImage src="../images/IMG_2037.jpeg" alt="slide3" />
        </div>
        <div>
          <StaticImage src="../images/IMG_1582.jpeg" alt="slide3" />
        </div>
      </Slider>
    </PageLayout>
  );
};

export default IndexPage;

export const Head = () => <title>Jobsworth Weekly</title>;
